import React from 'react';
import { useFormik } from 'formik';
import * as Yup from 'yup';
import styles from './wizardEnquiryForm.module.css';
import { Back, Close } from '../../../Svg';
import { useLocation, useNavigate } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { sendWizardEnquiryThunk } from '../../redux/wizardSlice';

const WizardEnquiryForm = () => {
    const location = useLocation();


    const data = location.state


    const { loading } = useSelector(state => state.wizard)
    const navigate = useNavigate()
    const dispatch = useDispatch()


    const getBreakQtyDetails = (quantityTable, quantity) => {
        if (!Array.isArray(quantityTable) || quantityTable.length === 0) {
            return { breakQty: 1, unitPrice: 0 };
        }
        const sortedTable = [...quantityTable]?.sort((a, b) => (a?.breakQty || 0) - (b?.breakQty || 0));
        return sortedTable.find((entry) => quantity <= entry?.breakQty) || sortedTable[sortedTable.length - 1] || { breakQty: 1, unitPrice: 0 };
    };

    const calculateTotal = () => {
        return data?.reduce((total, product) => {

            const priceDetails = getBreakQtyDetails(product.quantityTable, product.quantity);

            const unitPrice = priceDetails ? priceDetails.unitPrice : 0;

            return total + product.quantity * unitPrice;
        }, 0);
    };



    const formik = useFormik({
        initialValues: {
            partList: data?.map(item => {
                const { unitPrice } = getBreakQtyDetails(item?.product?.quantityTable, item?.quantity)

                return ({
                    productNumber: item.productNumber || '',
                    manufacturer: item.manufacturer || '',
                    quantity: item.quantity || '',
                    expectedPrice: item.expectedPrice || '',
                    requiredDate: item.requiredDate || '',
                    masterPrice: (unitPrice * item?.quantity) || 0
                })
            }
            )
        },
        validationSchema: Yup.object({
            partList: Yup.array().of(
                Yup.object().shape({
                    quantity: Yup.number().required('Required'),
                    expectedPrice: Yup.number().required('Required'),
                    requiredDate: Yup.string()
                })
            )
        }),
        onSubmit: async values => {
            const status = await dispatch(sendWizardEnquiryThunk(values))
            if (status.payload == 200) {
                navigate(-1)
            }
        }
    });
    console.log(formik.values);


    return (
        <>
            <div className={styles.imgBread}>
                <span>Wizard Tool</span>
            </div>
            <div className={styles.exInContainer}>
                <div>
                    <button className={styles.compBtn} onClick={() => navigate(-1)}><Back />Back to previous page</button>
                </div>
                <div className={styles.exInForm}>
                    <p>Please fill out the quote request form below and an Electrowiz representative will contact you shortly.</p>
                    <span className={styles.previewTitle}>Part list</span>
                    <div className={styles.hrLine}></div>

                    <form onSubmit={formik.handleSubmit}>
                        <div className={styles.productTableContainerscroll}>
                            <table className={styles.previewtable}>
                                <thead>
                                    <tr>
                                        <th className={styles.previewth}>Sl No</th>
                                        <th className={styles.previewth}>Manufacture Part #</th>
                                        <th className={styles.previewth}>Manufacture/Purchase Order #</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {formik.values.partList.map((item, index) => (
                                        <React.Fragment key={index}>
                                            <tr className={styles.previewstripedRow}>
                                                <td className={styles.previewtd}>{index + 1}</td>
                                                <td className={styles.previewtd}>{item.productNumber}</td>
                                                <td className={styles.previewtd}>
                                                    <div className={styles.closetd}>
                                                        {item.manufacturer} <Close />
                                                    </div>
                                                </td>
                                            </tr>
                                            <tr>
                                                <td colSpan="4">
                                                    <div className={styles.qrForm}>
                                                        <span className={styles.previewTitle}>Enquiry Form</span>
                                                        <div className={styles.qrForminputMain}>
                                                            <div className={styles.qrForminputs}>
                                                                <div className={styles.loginInputGroup}>
                                                                    <label>Required Quantity*</label>
                                                                    <input
                                                                        type="text"
                                                                        name={`partList[${index}].quantity`}
                                                                        value={formik.values.partList[index].quantity}
                                                                        onChange={(e) => {
                                                                            formik.handleChange(e);
                                                                            const newQuantity = Number(e.target.value) || 0;
                                                                            const unitPrice = getBreakQtyDetails(data[index]?.product?.quantityTable, newQuantity)?.unitPrice || 0;
                                                                            formik.setFieldValue(`partList[${index}].masterPrice`, unitPrice * newQuantity);
                                                                        }}
                                                                        onBlur={formik.handleBlur}
                                                                        placeholder="Enter quantity"
                                                                    />

                                                                    {formik.touched.partList?.[index]?.quantity && formik.errors.partList?.[index]?.quantity && (
                                                                        <div className={styles.error}>{formik.errors.partList[index].quantity}</div>
                                                                    )}
                                                                </div>
                                                                <div className={styles.loginInputGroup}>
                                                                    <label>Expected Price*</label>
                                                                    <input
                                                                        type="text"
                                                                        name={`partList[${index}].expectedPrice`}
                                                                        value={formik.values.partList[index].expectedPrice}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        placeholder="Enter expected price"
                                                                    />
                                                                    {formik.touched.partList?.[index]?.expectedPrice && formik.errors.partList?.[index]?.expectedPrice && (
                                                                        <div className={styles.error}>{formik.errors.partList[index].expectedPrice}</div>
                                                                    )}
                                                                </div>
                                                                <div className={styles.loginInputGroup}>
                                                                    <label>Required Date</label>
                                                                    <input
                                                                        type="date"
                                                                        name={`partList[${index}].requiredDate`}
                                                                        value={formik.values.partList[index].requiredDate}
                                                                        onChange={formik.handleChange}
                                                                        onBlur={formik.handleBlur}
                                                                        placeholder="Enter required date"
                                                                    />
                                                                    {formik.touched.partList?.[index]?.requiredDate && formik.errors.partList?.[index]?.requiredDate && (
                                                                        <div className={styles.error}>{formik.errors.partList[index].requiredDate}</div>
                                                                    )}
                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div className={styles.hrLine}></div>
                                                    </div>
                                                </td>
                                            </tr>
                                        </React.Fragment>
                                    ))}
                                </tbody>
                            </table>
                        </div>
                        <div className={styles.displayFlex}>
                            <button type="button" className={styles.cancelBtn} onClick={() => navigate(-1)}>Back</button>
                            <button type="submit" className={styles.submitBtn} disabled={loading}>{loading ? "please wait" : "Submit"}</button>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
};

export default WizardEnquiryForm;
